import { memo } from "react";
import sprites from "@/shared/assets/sprite.svg";
import { BaseIcon } from "./BaseIcon";

interface Props extends React.SVGProps<SVGSVGElement> {
	className?: string;
}

export const EditIcon: React.FC<Props> = memo(
	({ className, ...otherProps }) => {
		return (
			<BaseIcon
				className={className}
				title="Edit"
				aria-label="edit"
				{...otherProps}
			>
				<use xlinkHref={`${sprites}#edit-pencil`} />
			</BaseIcon>
		);
	},
);

EditIcon.displayName = "EditIcon";
